import { useTranslation } from 'react-i18next'
import { TranslationRead } from '@/api/dashboard'
import { FloatingMenuProps } from '@/ui'
import { Menu, MenuItem } from '@dashboard/ui'

interface TranslationMenuProps extends FloatingMenuProps {
  translation: TranslationRead
  onOpenOverlay: () => void
}

export const TranslationMenu = ({ onOpenOverlay, onClose }: TranslationMenuProps) => {
  const { t } = useTranslation()

  const onClickOpenOverlay = () => {
    onClose?.()
    window.requestAnimationFrame(() => {
      onOpenOverlay()
    })
  }

  return (
    <Menu>
      <MenuItem onClick={onClickOpenOverlay}>{t('localization.translation.menu.open-overlay')}</MenuItem>
    </Menu>
  )
}
